import { initialState } from "./State";
import { ExtendedFieldsActionTypes } from "us.collection.admin/constants/Actions";

const {
  MANAGE_DRAWER,
  GET_EXTENDED_FIELDS,
  GET_EXTENDED_FIELDS_SUCCESS,
  GET_EXTENDED_FIELDS_FAILURE,

  GET_EXTENDED_FIELD_SP_LIST,
  GET_EXTENDED_FIELD_SP_LIST_SUCCESS,
  GET_EXTENDED_FIELD_SP_LIST_FAILURE,

  GET_DATA_TYPES,
  GET_DATA_TYPES_SUCCESS,
  GET_DATA_TYPES_FAILURE,

  NEW_EXTENDED_FIELD,
  NEW_EXTENDED_FIELD_SUCCESS,
  NEW_EXTENDED_FIELD_FAILURE,

  UPDATE_EXTENDED_FIELD,
  UPDATE_EXTENDED_FIELD_SUCCESS,
  UPDATE_EXTENDED_FIELD_FAILURE,
} = ExtendedFieldsActionTypes;

export default (state = initialState, { payload, type }: any) => {
  switch (type) {
    case GET_EXTENDED_FIELDS:
      return Object.assign({}, state, {
        fields: {
          ...state.fields,
          isLoading: true,
        },
      });
    case GET_EXTENDED_FIELDS_SUCCESS:
      return Object.assign({}, state, {
        fields: {
          isLoading: false,
          data: payload.data,
        },
      });
    case GET_EXTENDED_FIELDS_FAILURE:
      return Object.assign({}, state, {
        fields: {
          ...state.fields,
          isLoading: false,
        },
      });
    case MANAGE_DRAWER:
      return Object.assign({}, state, {
        drawerInfo: {
          ...state.drawerInfo,
          ...payload.data,
          visible: !state.drawerInfo.visible,
        },
      });
    case GET_EXTENDED_FIELD_SP_LIST:
      return Object.assign({}, state, {
        storedProcedures: {
          data: [],
          isLoading: true,
        },
      });
    case GET_EXTENDED_FIELD_SP_LIST_SUCCESS:
      return Object.assign({}, state, {
        storedProcedures: {
          isLoading: false,
          data: payload.data,
        },
      });
    case GET_EXTENDED_FIELD_SP_LIST_FAILURE:
      return Object.assign({}, state, {
        storedProcedures: {
          ...state.fields,
          isLoading: false,
        },
      });
    case GET_DATA_TYPES:
      return Object.assign({}, state, {
        dataTypes: {
          ...state.dataTypes,
          isLoading: true,
        },
      });
    case GET_DATA_TYPES_SUCCESS:
      return Object.assign({}, state, {
        dataTypes: {
          data: payload.data,
          isLoading: false,
        },
      });
    case GET_DATA_TYPES_FAILURE:
      return Object.assign({}, state, {
        dataTypes: {
          ...state.dataTypes,
          isLoading: false,
        },
      });

    case UPDATE_EXTENDED_FIELD:
      return Object.assign({}, state, {
        isFieldSaving: true,
      });
    case UPDATE_EXTENDED_FIELD_SUCCESS:
      return Object.assign({}, state, {
        isFieldSaving: false,
      });
    case UPDATE_EXTENDED_FIELD_FAILURE:
      return Object.assign({}, state, {
        isFieldSaving: false,
      });

    case NEW_EXTENDED_FIELD:
      return Object.assign({}, state, {
        isFieldSaving: true,
      });
    case NEW_EXTENDED_FIELD_SUCCESS:
      return Object.assign({}, state, {
        isFieldSaving: false,
      });
    case NEW_EXTENDED_FIELD_FAILURE:
      return Object.assign({}, state, {
        isFieldSaving: false,
      });
    default:
      return state;
  }
};
